import * as SOCKJS from "sockjs-client";
import * as StompJs from "@stomp/stompjs";

const websocketUrl = "https://websocket-engine.rccgjc.com";

export const client = (token) => new StompJs.Client({
    webSocketFactory: function () {
        return new SOCKJS(`${websocketUrl}/ws`);
    },
    reconnectDelay: 5000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
    connectHeaders: {
        authorization: `Bearer ${token}`
    },
    disconnectHeaders: {
        authorization: `Bearer ${token}`
    }
});
